import { render } from "./home-three-feature.vue?vue&type=template&id=523c68e6"
import script from "./home-three-feature.vue?vue&type=script&lang=js"
export * from "./home-three-feature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__